import React from 'react'
  import { MDXTag } from '@mdx-js/tag'


  const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }
  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}>{`We may revise these terms of service for its website at any time without notice.
By using this website you are agreeing to be bound by the then current version of these terms of service.`}</MDXTag>
           </MDXTag>;
  }
}
MDXContent.isMDXComponent = true;
export const _frontmatter = {};
      